import React from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import WarningIcon from "@mui/icons-material/Warning";

const Root = styled(Box)(({ theme }) => ({
  color: "red",
  height: "100vh",
  width: "100vw",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#EBEDEF",
}));

const Error = (props) => {
  return (
    <>
      <Root>
        <Box>
          <Typography variant="h3" gutterBottom>
            <WarningIcon fontSize="100px" /> Error!
          </Typography>
          {props.msg ? (
            <Typography variant="h5" gutterBottom>
              {props.msg}
            </Typography>
          ) : (
            ""
          )}
        </Box>
      </Root>
    </>
  );
};

export default Error;
